// Takes PushSubscription data from server and stores it in object with helper methods
// for accessing it.

import FrontEndModel from './FrontEndModel';

export default class PushSubscription extends FrontEndModel {}
